<template>
    <div class="table">
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="学生姓名"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="班级名称"></el-input>
                    </div>
                </div>

                 <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.classTimeName" placeholder="上课名称"></el-input>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.status" clearable placeholder="考勤状态">
                            <el-option
                                v-for="item in statuss"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                         </el-select>
                    </div>
                </div>

                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        style="width:150px;"
                        v-model="form.workDate"
                        type="datetime"
                        placeholder="签到日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;float:right;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    &nbsp;&nbsp;
                    <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="450"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="学生姓名" width="100"></el-table-column>
                <el-table-column prop="deptName" label="年级名称" width="100"></el-table-column>
                <el-table-column prop="deptIdstrName" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="className" label="上课名称" width="100"></el-table-column>
                <el-table-column prop="title1" label="考勤时间段" ></el-table-column>
                <el-table-column prop="workDate" label="考勤时间" width="100"></el-table-column>
                <el-table-column prop="status" label="考勤状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                            正常
                        </div>
                        <div v-else-if="scope.row.status == 2">
                            缺勤
                        </div>
                        <div v-else-if="scope.row.status == 3">
                            请假
                        </div>
                        <div v-else-if="scope.row.status == 0">
                            未知
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column> 
                <el-table-column prop="teacherId" label="审核人" width="100"></el-table-column>
                <el-table-column prop="pushStatus" label="推送状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.pushStatus == 1">
                            待推送
                        </div>
                        <div v-else-if="scope.row.pushStatus == 2">
                            已推送
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="生成时间" width="100"></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import http from '../../../../common/http';

    export default {
        name:"Student",
        data(){
            return{
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    workDate:"",
                    deptId:"",
                    gradeName:"",
                    className:"",
                    classTimeName:"",
                    status:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                statuss:[{
                    value: "",
                    label: '全部'
                },{
                    value: 1,
                    label: '正常'
                },{
                    value: 2,
                    label: '缺勤'
                }, {
                    value: 3,
                    label: '请假'
                }],
                depts:[],
                data:[]
            }
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // deptCheck(){
            //    this.deptId=this.$refs['rootTree'].getCheckedKeys();
            //    this.getData();
            // },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listStudentUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    workDate:this.form.workDate==null?"":this.form.workDate,
                    deptId:this.form.deptId,
                    gradeName:this.form.gradeName,
                    className:this.form.className,
                    classTimeName:this.form.classTimeName,
                    status:this.form.status
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            exportExcel(){
                let msg="导出学生考勤数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.excelDownloadStudentUrl;
                let param = new URLSearchParams();
                // param.append('isPage', this.common.isPage);
                // param.append('page', this.common.page);
                // param.append('limit', this.common.pageSize);
                param.append('name', this.form.name);
                param.append('workDate', this.form.workDate==null?"":this.form.workDate);
                param.append('deptId', this.form.deptId);
                param.append('gradeName', this.form.gradeName);
                param.append('className', this.form.className);
                param.append('classTimeName', this.form.classTimeName);
                param.append('status', this.form.status);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '学生无感考勤.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/count/student/Student.vue